import { render, staticRenderFns } from "./SlotPicker.vue?vue&type=template&id=27ed09c0&scoped=true&"
import script from "./SlotPicker.vue?vue&type=script&lang=js&"
export * from "./SlotPicker.vue?vue&type=script&lang=js&"
import style0 from "./SlotPicker.vue?vue&type=style&index=0&id=27ed09c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ed09c0",
  null
  
)

export default component.exports